import React from "react";
import Section from "../ui/Section";
import SocialLinks from "../ui/SocialLinks";
import { contact } from "../../data/profile";

function Contact() {
  return (
    <Section id="contact">
      <div className="contact">
        <p className="section__eyebrow">Contact</p>
        <h2 className="contact__title">Let us build something</h2>
        <p className="contact__text">
          I am open to internships, collaborations, and conversations about
          software, machine learning, and everything adjacent. The fastest way
          to reach me is email.
        </p>

        <a className="contact__email" href={`mailto:${contact.email}`}>
          {contact.email}
        </a>

        <SocialLinks />
      </div>
    </Section>
  );
}

export default Contact;
